import filesize from 'filesize'

type Symbols = Parameters<typeof filesize>[1]['symbols']
const symbols: Symbols = { KB: 'kB' }

export function getStandardFileSizeString(sizeInBytes: number) {
  return filesize(sizeInBytes, { base: 2, standard: 'jedec', round: 1, symbols })
}

export const extractBase64FromDataURL = (dataURL: string): string => {
  if (!dataURL.startsWith('data:')) {
    return dataURL // Not a dataURL - probably already a base64 string
  }

  // This seems to be by far one of the most performant ways,
  // beware of changing it. Using a simple regex hogs CPU for seconds
  const base64StartIndex = dataURL.indexOf(';base64,') + ';base64,'.length
  return dataURL.substring(base64StartIndex)
}

export function getFileExtension(filename: string) {
  const lastDotIndex = filename.lastIndexOf('.')

  return lastDotIndex !== -1 // I <3 PRETTIER
    ? filename.substring(lastDotIndex + 1).toLowerCase()
    : ''
}
